import React, { useEffect } from 'react';
import '../styles/basketItemDiscount.css';
import '../styles/summary.css';
import SelectedCoupon from './SelectedCoupon';
import RemovableCoupon from './RemovableCoupon';
import Payment from './Payment';
import { useDispatch, useSelector } from 'react-redux';
import { loaderActions } from "../store/loaderSlice";

export default function SelectedCoupons() {
    const dispatch = useDispatch();
    const selectedCoupons = useSelector(state => state.coupons.selectedCoupons);
    const removableCoupons = useSelector(state => state.coupons.removableCoupons);
    const payments = useSelector(state => state.coupons.payments);
    const selectedCombination = useSelector(state => state.coupons.selectedCombination);
    const displayedSelectedCoupons = selectedCoupons || [];

    const showSelectedCoupons = displayedSelectedCoupons.length > 0
        || payments && payments.payments && payments.payments.length > 0 && payments.payments[0].used_amount !== 0
        || removableCoupons && removableCoupons.length > 0;

    useEffect(() => {
        dispatch(loaderActions.loaderHide());
    }, [selectedCombination]);

    return (
        <>
            {showSelectedCoupons &&
                <div
                  className="summary_selected_coupons summary_container"
                  data-testid="summary-selected-coupons"
                >
                    {displayedSelectedCoupons.map((selectedCoupon, id) =>
                        <SelectedCoupon key={id} selectedCoupon={selectedCoupon} />
                    )}
                    {payments && payments.payments && payments.payments.length > 0 && payments.payments[0].used_amount !== 0 &&
                        <Payment payment={parseFloat(payments.payments[0].used_amount).toFixed(2)} />
                    }
                    {removableCoupons && removableCoupons.length > 0 && removableCoupons.map((removableCoupon, id) =>
                        <RemovableCoupon key={id} removableCoupon={removableCoupon} />
                    )}
                </div>}
        </>
    )
}
